module.exports = __webpack_public_path__ + "img/有限数量.5b6208a7.jpg";